import React from "react";
import { InlineNotice } from "./ui";

export type CountsMetadata = { countsStatus?: string; message?: string; countsSnapshot?: {
  startedAt?: string | null; completedAt?: string | null; refreshStartedAt?: string | null; error?: string | null;
} };

export function OverviewCountsNotice({ countsStatus, message, countsSnapshot: snapshot }: CountsMetadata) {
  return <>
    {message ? <InlineNotice tone={countsStatus === "UNAVAILABLE" || countsStatus === "STALE" ? "warning" : "info"}><span className="overview-count-message">{message}</span></InlineNotice> : null}
    {snapshot?.completedAt ? <div className="overview-count-freshness"><span>Record counts collected {snapshot.startedAt ? new Date(snapshot.startedAt).toLocaleString() : "earlier"} – {new Date(snapshot.completedAt).toLocaleString()}. Counts refresh in the background.</span>{snapshot.refreshStartedAt ? <span>{snapshot.error ? "The count refresh will retry automatically." : "A new count is in progress."}</span> : null}</div> : null}
    {snapshot?.error && countsStatus === "STALE" ? <InlineNotice tone="warning"><span className="overview-count-message">Count refresh failed: {snapshot.error}. The previous completed count is shown.</span></InlineNotice> : null}
  </>;
}
